import { render, staticRenderFns } from "./ThirdPartyBizBusinessinfoReport.vue?vue&type=template&id=71526bca&"
import script from "./ThirdPartyBizBusinessinfoReport.vue?vue&type=script&lang=js&"
export * from "./ThirdPartyBizBusinessinfoReport.vue?vue&type=script&lang=js&"
import style0 from "./ThirdPartyBizBusinessinfoReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports